import React from 'react';
import tinycolor2 from 'tinycolor2';
import styles from './Tag.module.scss';
import Icon from '../../icons/Icon';

export default function Tag(props) {
    const { tag, option, color, children, onRemove } = props;

    return (
        <span
            className={styles.Tag}
            style={{
                backgroundColor: color,
                borderColor: tinycolor2(color).darken().toString(),
            }}>
            <span className={styles.text}>{children}</span>
            {onRemove && (
                <button type="button" onClick={() => onRemove(tag, option)}>
                    <Icon color="white" src="/img/reject_icon.png" />
                </button>
            )}
        </span>
    );
}
